import trackEvent from "@lib/trackers";

import { BulkshiftCreatedShiftEventName, createAnalyticsTracker } from "./generated";

export const analytics = createAnalyticsTracker((eventName, params) => {
    void trackEvent({
        name: eventName,
        params,
    });
});

export const bulkshiftCreatedShift = analytics.event(BulkshiftCreatedShiftEventName);
